/**
 * Application Constants
 */

// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || window.location.origin;

// Application Settings
export const APP_NAME = 'Intranet';
export const APP_TAGLINE = 'Company Portal';

// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

// Debounce Timing
export const SEARCH_DEBOUNCE_MS = 300;

// Role Types
export const ROLE_TYPES = {
  C_LEVEL: 'C-Level',
  MANAGEMENT: 'Management',
  INDIVIDUAL_CONTRIBUTOR: 'Individual Contributor',
};

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
};

// Legal Entities (for payroll/billing)
export const LEGAL_ENTITIES = {
  SQS_BUSINESS: 'SQS Business Services',
  SIQSESS_TECH: 'Siqsess Technology SRL',
};

export const LEGAL_ENTITY_OPTIONS = Object.values(LEGAL_ENTITIES);

// Client/Project Entities (for vendor costs, overhead, project allocation)
export const CLIENT_ENTITIES = [
  { name: 'Know IT Solutions', abbreviation: 'KIS' },
  { name: 'Akira Solutions', abbreviation: 'AKI' },
  { name: 'Vortech Business Solutions', abbreviation: 'VOR' },
  { name: 'Sorexo Business', abbreviation: 'SRX' },
  { name: 'AxelCoreOU', abbreviation: 'AxelCoreOU' },
  { name: 'AxelCoreUS', abbreviation: 'AxelCoreUS' },
];

// Client entity abbreviations for dropdowns
export const CLIENT_ENTITY_ABBREVIATIONS = CLIENT_ENTITIES.map(e => e.abbreviation);

// Client entity full names for dropdowns
export const CLIENT_ENTITY_NAMES = CLIENT_ENTITIES.map(e => e.name);

// All entities combined (for vendor cost owner dropdown)
export const ALL_ENTITY_NAMES = [
  ...LEGAL_ENTITY_OPTIONS,
  ...CLIENT_ENTITY_NAMES,
  'Martin Enterprises',
];

// Helper to get abbreviation from entity name
export function getEntityAbbreviation(entityName) {
  if (!entityName) return '';
  const lower = entityName.toLowerCase();

  // Check legal entities
  if (lower.includes('siqsess')) return 'Siqsess';
  if (lower.includes('sqs')) return 'SQS';

  // Check client entities
  const found = CLIENT_ENTITIES.find(e =>
    lower.includes(e.name.toLowerCase()) || lower === e.abbreviation.toLowerCase()
  );
  if (found) return found.abbreviation;

  // Fallback mappings
  if (lower.includes('know it')) return 'KIS';
  if (lower.includes('akira')) return 'AKI';
  if (lower.includes('vortech')) return 'VOR';
  if (lower.includes('sorexo')) return 'SRX';
  if (lower.includes('axelcoreou')) return 'AxelOU';
  if (lower.includes('axelcoreus')) return 'AxelUS';
  if (lower.includes('martin')) return 'Martin';

  return entityName;
}
